import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { toApiError } from "src/types/api";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";

export interface iGetSignupAutoUpdateState {
  isLoading: boolean;
  message: string;
  error: string;
  response: {
    auto_approve : boolean
  }
}

const initialState: iGetSignupAutoUpdateState = {
  isLoading: false,
  message: "",
  error: "",
  response: null,
};

export const getSignupAutoUpdateState = createAsyncThunk(
  "GET_SIGNUP_AUTO_UPDATE",
  async (_, { rejectWithValue }) => {
    const djangoEndpoint = getDjangoEndpoint();
    const pathParam = "/auth/admin/signup-auto-check/";

    try {
      const response = await axiosInstance.get(
        `${djangoEndpoint}${pathParam}`,
        {
          withCredentials: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Email check API error:", error);
      const apiError = toApiError(error);
      return rejectWithValue(apiError.response?.data || { message: apiError.message });
    }
  }
);

export const signupAutoUpdateSlice = createSlice({
  name: "GetSignupAutoUpdate",
  initialState,
  reducers: {

    resetSignUpAutoUpdate: (state) => {
      state.isLoading = false;
      state.message = "";
      state.error = "";
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSignupAutoUpdateState.pending, (state) => {
        state.isLoading = true;
        state.message = "";
        state.error = "";
      })
      .addCase(getSignupAutoUpdateState.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
        // state.error = "e"
        state.message =
          action.payload?.message ||
          action.payload?.detail ||
          action.payload?.result ||
          "";
      })
      .addCase(getSignupAutoUpdateState.rejected, (state, action) => {
        state.isLoading = false;
        state.response = null;
        state.error =
          (action.payload as any)?.message ||
          (action.payload as any)?.detail ||
          action.error.message ||
          "Email verification request failed.";
      });
  },
});

export const { resetSignUpAutoUpdate } = signupAutoUpdateSlice.actions;

export default signupAutoUpdateSlice.reducer;
